<template>
  <v-container fluid>
    <PageTitle icon="fal fa-fw fa-fax">
      Fax Messages

      <template v-slot:buttons>
        <v-btn :to="{name: `${$root.routePrefix}.send_fax`}"
               color="primary"
               class="mr-2">
          Send fax
        </v-btn>
        <v-btn :to="{name: `${$root.routePrefix}.fax_contacts.index`}"
               class="mr-2">
          Fax Contacts
        </v-btn>
        <v-btn @click.prevent="fetchData">
          Refresh
        </v-btn>
      </template>
    </PageTitle>

    <v-card>
      <v-card-text>
        <v-text-field v-model="search"
                      prepend-inner-icon="fal fa-search"
                      label="Search"
                      outlined
                      dense
                      hide-details>
        </v-text-field>
      </v-card-text>
      <fax-messages-paginated-table :loading="loading"
                                    :messages="messages"
                                    :search="search">
      </fax-messages-paginated-table>
    </v-card>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import faxService from '../../../services/faxService';
import FaxMessagesPaginatedTable from './components/FaxMessagesPaginatedTable';
import echo from '../../../plugins/echo';
import PageTitle from '../../../components/PageTitle.vue';

export default {
  components: {PageTitle, FaxMessagesPaginatedTable},
  data() {
    return {
      loading: false,
      messages: [],
      search: '',
    }
  },
  computed: {
    ...mapGetters([
      'isMember',
      'team',
      'user',
    ]),
  },
  created() {
    this.initEcho();
    this.fetchData();
  },
  methods: {
    initEcho() {
      echo.private(this.team.channel)
        .listen('Fax.FaxMessageEventProcessed', e => {
          console.log('FaxMessageEventProcessed', e);
          this.fetchData();
        })
    },
    fetchData() {
      this.loading = true;
      // Only show the messages sent by the current user.
      const params = {
        user_id: this.user.id,
      };
      faxService.getMessages(params)
        .then(data => {
          this.messages = data;
        })
        .finally(() => {
          this.loading = false;
        })
    },
  }
}
</script>
